/* eslint-disable  */
import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { connect } from 'react-redux';
import {
    Button, Table, Header, Divider, Segment, Checkbox
} from 'semantic-ui-react';
import { actions } from './sagaSlice';
import { FlexBox } from '../../styles/components';
import clone from 'lodash/cloneDeep';


import 'semantic-ui-css/semantic.min.css';

const Radio = props => (
    <div className='flex-column'>
        <label className='radio-label'>{props.label}</label>
        <input
            {...props}
            className='eval-radio'
            type='radio'
            onChange={props.input.onChange}
            value={props.input.value}
            name={props.input.name}
            checked={props.input.checked}
        />
    </div>
);

const TextArea = props => <textarea maxLength='3000' {...props} {...props.input} className={['text-area', props.className].filter(Boolean).join(' ')} />;

const LongEvalForm = props => {

    const { evaluation, update, actualJobTitle } = props;

    const onSubmit = values => {
        const payload = clone(values);
        payload.data.actual_job_title = actualJobTitle;
        update(payload);
    };

    // const onComplete = e => {

    //     e.preventDefault();
    //     if (window.confirm('You will no longer be able to edit this evaluation if you mark it as complete, are you sure?')) {

    //         const payload = {
    //             completed: true,
    //             employee: evaluation.employee,
    //             id: evaluation.id
    //         };
    //         update(payload);
    //         history.goBack();

    //     }
    // };

    return (
        <FinalForm
            initialValues={evaluation}
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine }) => (
                <form onSubmit={handleSubmit}>
                    
                    <div style={{
                        padding: "10px 0px 10px 0px"
                    }}> 
                    <Table celled className='pagebreak print-font'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='5'>
									Section I. <span style={{ marginLeft: '20px' }}>Basic Responsibilities and Performance Standards</span>
                                </Table.HeaderCell>
                                <Table.HeaderCell className='blue-header header-resize' width='2'>
                                    <div>4= Exceeds Expectations </div>
                                    <div>3= Meet Expectations </div>
                                    <div>2= Needs Improvement </div>
                                    <div>1= Below Expectations</div>
                                </Table.HeaderCell>
                                <Table.HeaderCell className='blue-header' width='5' textAlign='center'>
									Comments
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {evaluation.data.default.map((question, i) => (
                                <Table.Row key={`default-${i}`}>
                                    <Table.Cell>
                                        <Header size='small' content={question.descriptor} subheader={question.text} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <div className='flex-space'>
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'4'} label='4' />
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'3'} label='3' />
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'2'} label='2' />
                                            <Field component={Radio} type='radio' name={`data.default[${i}].rating`} value={'1'} label='1' />
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell>

                                        <Field component={TextArea} name={`data.default[${i}].comments`} />

                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    </div>
                    <div style={{
                        padding: "10px 0px 10px 0px"
                    }}> 
                    <Table className='print-font'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' colSpan='2'>
                                    <strong>
										Section II. <span style={{ marginLeft: '20px' }}>Employee Goals Set from Previous Evaluation in May</span>{' '}
                                    </strong>
                                </Table.HeaderCell>
                                <Table.HeaderCell className='blue-header' colSpan='1'>
                                    <strong>
										Comments
                                    </strong>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>

                            {Object.entries({
                                one: evaluation.goals.one,
                                two: evaluation.goals.two,
                                three: evaluation.goals.three,
                                four: evaluation.goals.four,
                                five: evaluation.goals.five
                            }).map(([key, goal]) => (
                                <React.Fragment key={`goals-${key}`}>
                                    <Table.Row>
                                        <Table.Cell className='goal-title' colSpan='3'>
                                            <label>Goal {key}: {goal.goal}</label>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            <Segment size='small' className='flex-space goal-rating'>
                                                <Field component={Radio} type='radio' name={`goals[${key}].rating`} value={'satisfactory'} label='SATISFACTORY' />
                                                <Divider vertical>OR</Divider>
                                                <Field component={Radio} type='radio' name={`goals[${key}].rating`} value={'UNSATISFACTORY'} label='UNSATISFACTORY' />
                                            </Segment>
                                        </Table.Cell>
                                        <Table.Cell width='10' colSpan='2'>

                                            <Field component={TextArea} name={`goals[${key}].comment`} />

                                        </Table.Cell>
                                    </Table.Row>
                                </React.Fragment>
                            ))}
                        </Table.Body>
                    </Table>
                    </div>
                    <div style={{
                        padding: "10px 0px 10px 0px"
                    }}>           
                    <Table className='print-mt print-font' id={'eval-section-comments'}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className='blue-header' width='4'>
                                    <strong>
										Section III. <span style={{ marginLeft: '20px' }}>Comments</span>{' '}
                                    </strong>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                    <Table.Body>
                        <React.Fragment>
                            <Table.Row>
                                <Table.Cell className='comment-area'>
                                    <Field id={'eval-section-comments-textarea'} className='print-fit' component={TextArea} name= {'comments'}/>
                                </Table.Cell>
                            </Table.Row>
                        </React.Fragment>
                    </Table.Body>
                    </Table>
                    </div>


                    <FlexBox justifyContent='space-between'>
                        <Button color='green' type='submit' disabled={submitting}>
							SAVE EVALUATION
                        </Button>


                        <Field name='completed'>
                            {({ input }) => (

                                <Checkbox
                                    // disabled={frozen}
                                    label='COMPLETED'
                                    toggle
                                    onChange={(e, { checked }) => input.onChange(checked)}
                                    checked={input.value}
                                />
                            )}
                        </Field>

                    </FlexBox>

                    <div style={{ display: 'flex', flexDirection: 'column', width: '400px', paddingTop: '4rem' }}>
                        <div style={{ borderBottom: '1px solid black', marginBottom: '20px', width: '75%' }}></div>
                        <p style={{ marginTop: '0' }}>Supervisor</p>
                        
                        <div style={{ borderBottom: '1px solid black', marginBottom: '20px', width: '75%', paddingTop: '2rem' }}></div>
                        <p style={{ marginTop: '0' }}>Team Member</p>
                    </div>


                    
                </form>
            )}
        />
    );
};

export default connect(
    null,
    actions
)(LongEvalForm);
